import React from "react";
import { Box, Typography, Stack } from "@mui/material";
import EventCard from "./EventCard";

function SearchResultsList({ events, searchQuery }) {
  if (events.length === 0) {
    return (
      <Box sx={{ py: 4, textAlign: "center" }}>
        <Typography color="text.secondary">
          No events found matching "{searchQuery}"
        </Typography>
      </Box>
    );
  }

  return (
    <Stack spacing={2} sx={{ width: "100%" }}>
      <Typography variant="subtitle2" color="text.secondary">
        Found {events.length} event(s)
      </Typography>
      {events.map((event) => (
        <EventCard key={event.eventID} event={event} />
      ))}
    </Stack>
  );
}

export default SearchResultsList;